export default __webpack_public_path__ + "static/sheettexture-42c1f3891bbfd6133407a79b1209040b.png";